import { dayjsLocalDateSchema } from "@/utils/zod.ts";
import { z } from "zod";

const numericStringSchema = z
    .string()
    .optional()
    .nullable()
    .refine(
        (val) => {
            if (val === null || val === undefined || val === "") {
                return true;
            }
            return /^-?\d*\.?\d+$/.test(val);
        },
        {
            message: "Must be a valid number",
        },
    );

export const addProviderSchema = z.object({
    idUUID: z.string().nullable().optional(),
    idCompanyID: z.string().optional().nullable(),
    providerStartDate: dayjsLocalDateSchema.optional().nullable(),
    providerEndDate: dayjsLocalDateSchema.optional().nullable(),
    providerSelfPay: numericStringSchema,
    providerMedPay: numericStringSchema,
    providerReductionApproved: z.string().optional().nullable(),
    providerReduction: numericStringSchema,
    providerClientToPay: numericStringSchema,
    note: z.string().optional().nullable(),
    selectedMedia: z.string().optional().nullable(),
    selectedRecord: z.string().optional().nullable(),
    providerBill: numericStringSchema,
    providerBalance: numericStringSchema,
    providerHealthInsPmt: numericStringSchema,
    providerAdjustment: numericStringSchema,

    companyName: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
    phoneExtension: z.string().optional().nullable(),
    faxNumber: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
});
